import {
  Button,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  TextField,
  Divider,
  Box
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useNotif } from 'src/hooks';
import { Alert, AlertTitle } from '@material-ui/lab';
import {
  invalidAddress,
  invalidWords
} from '../SubAccForm/components/Address/StracturedAddressData';
import DebounceTextField from '../DebounceTextField';
import LineProgress from '../LineProgress';
import { use } from 'react';

const PasteData = ({ pasteData, onClose, resultData, subTypeMeta, meta }) => {
  const notify = useNotif();
  const [textField, setTextField] = useState('');
  const [invalidPasted, setInvalidPasted] = useState(false);
  const [hasNewValue, setHasNewValue] = useState(false);

  const handleTextFieldChange = e => {
    const { value } = e.target;
    const badWords = invalidAddress({ word: value, settings: meta }, notify);
    const state = invalidWords(badWords);
    setInvalidPasted(state);
    setTextField(value);
    if (value) {
      setHasNewValue(false);
    }
  };

  const formattedDatasub = parsed => {
    const mapping = subTypeMeta?.mapping || {};
    const pretty_flds = subTypeMeta?.pretty_flds || {};
    const formattedData = Object.entries(mapping)
      .map(([index, fieldKey]) => ({
        id: Number(index) + 1,
        field: fieldKey,
        label: pretty_flds[fieldKey] || fieldKey,
        value: parsed[index] || ''
      }))
      .sort((a, b) => a.id - b.id);
    resultData(formattedData);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (event.ctrlKey) {
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const newValue =
          textField.slice(0, start) + '\n' + textField.slice(end);
        setTextField(newValue);

        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
        }, 0);
      } else {
        event.preventDefault();
        const parsed = textField.split('\n').map(line => line.trim());
        formattedDatasub(parsed);
        notify.success('Proceeding with Data');
        onClose(false);
      }
    }
  };

  useEffect(() => {
    if (pasteData) {
      try {
        if (!pasteData) {
          notify.error('Clipboard is empty');
          return;
        }
        const parsed = pasteData
          .replace(/\r\n/g, '\n')
          .split('\n')
          .map(line => line.trim());
        setTextField(parsed.join('\n'));
        const badWords = invalidAddress(
          { word: parsed.join('\n'), settings: meta },
          notify
        );
        const state = invalidWords({ value: badWords });
        setInvalidPasted(state);
        notify.success('Successfully pasted');
      } catch (err) {
        console.error('Clipboard read error:', err);
        notify.error('Failed to paste. Check clipboard permissions.');
      }
    }
  }, [pasteData, meta]);

  const handleProceed = () => {
    const parsed = textField.split('\n').map(line => line.trim());
    formattedDatasub(parsed);
    notify.success('Proceeding with Data');
    onClose(false);
  };

  return (
    <Dialog open={true} onClose={() => onClose(false)} maxWidth="sm" fullWidth>
      <DialogContent>
        <Alert severity="info">
          <AlertTitle>
            Please follow the order of details below, each separated by a new
            line:
          </AlertTitle>
          {Object.entries(subTypeMeta?.mapping)
            .sort(([indexA], [indexB]) => indexA - indexB)
            .map(([index, fieldKey]) => (
              <Typography
                variant="caption"
                display="block"
                key={index}
                sx={{ color: 'black', fontWeight: 'bold' }}
              >
                {`* ${subTypeMeta?.pretty_flds[fieldKey] || fieldKey}`}
              </Typography>
            ))}
        </Alert>

        <DebounceTextField
          label="Paste Data"
          multiline
          rows={8}
          variant="outlined"
          fullWidth
          margin="normal"
          value={textField}
          onChange={handleTextFieldChange}
          onKeyDown={handleKeyDown}
          delay={1000}
          actualValue={data => {
            if (data) {
              setHasNewValue(true);
            }
          }}
        />

        {hasNewValue && (
          <Box marginTop={0.5} marginBottom={0.5}>
            <LineProgress />
          </Box>
        )}

        <Typography variant="caption" display="block" gutterBottom="small">
          Press Enter or Proceed to parse, (ctrl + Enter to add a new line)
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button onClick={() => onClose(false)} size="small">
          Cancel
        </Button>
        <Button
          onClick={handleProceed}
          variant="contained"
          color="primary"
          size="small"
          disabled={invalidPasted || hasNewValue}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasteData;
